export default __webpack_public_path__ + "static/media/fad-digital5.4148716b.svg";